import React from "react";
import MasterTable from "../Grades/BaseMaster/MasterTable";

function CategoryTable() {
  return (
    <>
      <MasterTable
        endpoint="/category"
        name="Categories"
        modalName="Category"
      />
    </>
  );
}

export default CategoryTable;
